import { Action } from 'redux';
import IProject from '../../../types/Project';
import { PROJECTS_SET_PROJECTS, PROJECTS_SET_SELECTED_PROJECT } from '../projectsConstants';

export interface IStoreProjectsSetProjectsAction extends Action {
  type: typeof PROJECTS_SET_PROJECTS;
  payload: {
    projects: IProject[];
  };
}

export interface IStoreProjectsSetSelectedProjectAction extends Action {
  type: typeof PROJECTS_SET_SELECTED_PROJECT;
  payload: {
    selectedProject: IProject | null;
  };
}

export interface IStoreProjectsSetProjectsProps {
  projects: IProject[];
}

export interface IStoreProjectsSetSelectedProjectProps {
  selectedProject: IProject | null;
}

export const projectsSetProjectsAction = (
  payload: IStoreProjectsSetProjectsProps
): IStoreProjectsSetProjectsAction => ({
  payload,
  type: PROJECTS_SET_PROJECTS,
});

export const projectsSetSelectedProjectAction = (
  payload: IStoreProjectsSetSelectedProjectProps
): IStoreProjectsSetSelectedProjectAction => ({
  payload,
  type: PROJECTS_SET_SELECTED_PROJECT,
});
